import React, { useState } from 'react';

interface ConsoleLog {
    timestamp: string;
    message: string;
    type?: 'info' | 'error' | 'warning';
}

const Console: React.FC = () => {
    // In a full implementation, you would get logs from the IDE store
    const [logs] = useState<ConsoleLog[]>([
        {
            timestamp: '[12:13:50 AM]',
            message: 'moc version 0.14.9',
            type: 'info'
        },
        {
            timestamp: '[12:13:50 AM]',
            message: 'base library version moc-0.14.9',
            type: 'info'
        }
    ]);

    return (
        <div style={{
            height: '192px',
            backgroundColor: '#fdf6e3',
            borderTop: '1px solid #8B4513',
            overflow: 'auto',
            fontFamily: "'SF Mono', Monaco, Menlo, Consolas, 'Ubuntu Mono', monospace",
            fontSize: '14px',
            padding: '8px'
        }}>
            {logs.map((log, index) => (
                <div
                    key={index}
                    style={{
                        color: log.type === 'error' ? '#dc2626' :
                            log.type === 'warning' ? '#8B4513' :
                                '#5C4033',
                        marginBottom: '4px',
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    <span style={{color: '#685c4d'}}>{log.timestamp}</span> {log.message}
                </div>
            ))}
        </div>
    );
};

export default Console;